// extracted by mini-css-extract-plugin
export default {"selected":"_46bfb1fe2f","un":"d417d01c18"};